import { createSlice } from '@reduxjs/toolkit';

interface DashboardState {
  adminConsole: boolean;
}

const initialState: DashboardState = {
  adminConsole: false,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // Toggle admin console on/off when called
    switchAdmin: (state) => {
      state.adminConsole = !state.adminConsole;
    },
  },
});

export const { switchAdmin } = dashboardSlice.actions;
export default dashboardSlice.reducer;
